import React, { useCallback, useEffect, useState } from "react";
import Logo from "../assets/images/payloft-logo.png";
import WidgetImg from "../assets/images/payment-widget-img.png";
import Modal from "../components/Modal";
import { getPaymentLink, makePayment } from "../services/payment";
import toast from "react-hot-toast";
import Spinner from "../components/Spinner";

const Widget = () => {
  const [agreed, setAgreed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState({});
  const [previewImage, setPreviewImage] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [amount, setAmount] = useState(null);
  const [loading, setLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("v");

  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handlePhoneNumberChange = (event) => {
    // Allow only numeric characters
    const inputText = event.target.value.replace(/\D/g, "");

    // Limit the input to a maximum of 10 characters
    const truncatedInput = inputText.slice(0, 11);

    // Update the input value
    event.target.value = truncatedInput;
    setPhoneNumber(event.target.value);
  };

  const getLink = useCallback(async () => {
    try {
      const res = await getPaymentLink(code);
      setData(res.data);
      setAmount(res.data.amount);
      if (res.data.image) {
        // Convert binary data to a data URL
        const dataUrl = `data:image/jpeg;base64,${res.data.image}`;
        setPreviewImage(dataUrl);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  }, [code]);

  useEffect(() => {
    getLink();
  }, [getLink]);

  const increaseAmount = () => {
    setAmount((prevAmount) => prevAmount + 1);
  };

  const decreaseAmount = () => {
    setAmount((prevAmount) => (prevAmount > 1 ? prevAmount - 1 : prevAmount));
  };

  const createPayment = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await makePayment({
        Id: data.merchantCode,
        Description: data.description,
        Amount: amount,
        Fee: 0,
        Currency: data.currency,
        CustomerEmail: email,
        Email: email,
        PhoneNumber: phoneNumber,
        CustomerName: data.customerName,
        SecretKey: data.secretKey,
        PaymentLinkId: data.id,
      });
      setLoading(false);
      window.location.href = `https://pay.mypayloft.com/${res.data.id}`;
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="bg-arena-background min-h-screen flex justify-center">
      <div className="bg-white w-[448px] h-auto">
        <div className="flex justify-center">
          <img src={Logo} alt="logo" className="w-[92px] h-auto mt-8 " />
        </div>
        {data.image ? (
          <div className="flex justify-center">
            <img
              src={previewImage}
              alt="widget-img"
              className="w-auto h-auto cursor-pointer"
              onClick={openModal}
            />
          </div>
        ) : null}
        <div className="w-full px-12">
          <div className="flex flex-col items-center pb-5 border-b-2">
            <h1 className="text-navyblue text-[25px] text-center w-[169px] text-wrap font-semibold">
              {data?.title}
            </h1>
            <p className="text-navyblue text-[13px] text-center w-[223px] font-normal">
              {data?.description}
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center mt-4 relative">
          {/* <button
            className="bg-white rounded-full border border-light-grey w-16 h-16 relative"
            onClick={decreaseAmount}
            disabled={amount <= 1 || data.isAmountPreset}
          >
            <span className="bg-black w-4 h-[2px] absolute left-[22px] top-1/2 transform -translate-y-1/2"></span>
          </button> */}
          <div
            className={`${
              data.isAmountPreset ? "absolute left-14 md:left-20" : ""
            } text-[70px]`}
          >
            {data?.currencySymbol === "N" ? "₦" : data?.currencySymbol}
          </div>

          <input
            type="text"
            value={amount}
            onChange={(e) => {
              const value = e.target.value;
              // Regular expression to match numbers with up to 2 decimal places
              const regex = /^[0-9]*\.?[0-9]{0,2}$/;

              if (regex.test(value)) {
                setAmount(value);
              }
            }}
            pattern="[0-9]*\.?[0-9]{0,2}"
            className="font-medium text-[70px] text-dark-black border-none bg-white w-[80%] text-center focus:outline-none"
            disabled={data.isAmountPreset}
          />

          {/* <button
            className="bg-white rounded-full border border-light-grey w-16 h-16 relative"
            onClick={increaseAmount}
            disabled={data.isAmountPreset}
          >
            <span className="text-3xl absolute left-[22px] top-[26px] transform -translate-y-1/2">
              +
            </span>
          </button> */}
        </div>
        {/* {data.isAmountPreset ? (
          <p className="text-center font-semibold text-[15px]">
            The amount is not editable
          </p>
        ) : (
          <p className="text-center font-semibold text-[15px]">
            The amount is editable
          </p>
        )} */}
        <div className="flex flex-col items-center mt-4">
          <form onSubmit={createPayment}>
            {data?.isPhoneNumberRequired && (
              <div className="flex flex-col">
                <label
                  htmlFor="phoneNumber"
                  className="text-base font-normal text-navy-blue"
                >
                  Phone Number
                </label>
                <input
                  type="text"
                  id="phoneNumber"
                  onChange={handlePhoneNumberChange}
                  className="w-[348px] h-[50px] bg-form-background rounded-md mt-2 px-2 focus:outline-none"
                  required
                />
              </div>
            )}
            {data?.isEmailRequired && (
              <div className="flex flex-col mt-4">
                <label
                  htmlFor="email"
                  className="text-base font-normal text-navy-blue"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-[348px] h-[50px] bg-form-background rounded-md mt-2 px-2 focus:outline-none"
                  required
                />
              </div>
            )}
            <div className="flex items-center gap-2 mt-24">
              <input
                type="checkbox"
                className="w-[15px] h-[15px]"
                checked={agreed}
                onChange={handleCheckboxChange}
              />
              <p className="w-[322px] text-base font-normal text-navy-blue mt-5">
                By accepting this, you agree to the{" "}
                <span className="underline text-btn-blue">terms of use</span>{" "}
                and our{" "}
                <span className="underline text-btn-blue">privacy policy</span>.
              </p>
            </div>
            <button
              className="w-[348px] h-[46.72px] bg-btn-blue text-white rounded-md mt-5 disabled:bg-btn-blue/20"
              type="submit"
              disabled={!agreed}
            >
              {loading ? <Spinner /> : "Proceed to Payment"}
            </button>
            <p className="text-center text-base font-normal text-navy-blue mt-5 mb-5">
              Powered by Payloft
            </p>
          </form>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <img
          src={previewImage}
          alt="Full view"
          className="w-full h-full object-cover"
        />
      </Modal>
    </div>
  );
};

export default Widget;
